<template>
  <div class="venues">
    <levels/>
    <div class="detail-pane">
      <div class="detail-pane__image-wrapper venue-detail-pane-width">
        <div id="image-slider" class="venues-slider">
          <image-slider
              :slides="images"
              :tip-str-show="false"
              transition-type="slide-fade">
            <div slot="loader" class="spinner centered" id="spinner"></div>
          </image-slider>
        </div>
        <spinner v-if="isLoading"/>
      </div>
      <div class="control-footer venue-detail-pane-width">
        <!-- IMAGE SLIDER CONTROLS -->
        <slider-controls @full-screen="toggleFullScreen"></slider-controls>
      </div>
      <venue/>
    </div>
    <!--        <v-touch @swipeleft="toggleDetailPanel(false)" @swiperight="toggleDetailPanel(true)">

            </v-touch>-->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

// @ is an alias to /src
import Levels from '@/components/Levels'
import Venue from '@/components/Venue'
import ImageSlider from '@/components/image-slider/ImageSlider.vue';
import SliderControls from '@/components/image-slider/SliderControls.vue';
import Spinner from '@/components/image-slider/Spinner.vue';
// import image


export default {
  name: 'venues',
  components: {
    Spinner,
    'image-slider': ImageSlider,
    'slider-controls': SliderControls,
    Levels,
    Venue
  },
  data() {
    return {
      debug: false,
      errors: []
    }
  },
  computed: {
    ...mapState([
      'wpUrl',
      'selectedLevel',
      'images',
      'isLoading'
    ]),
    venues: {
      get() {
        return this.$store.state.venues;
      },
      set(venues) {
        this.setVenues(venues);
      }
    }
  },
  methods: {
    ...mapMutations([
      'setLevels',
      'setVenue',
      'setVenues',
      'toggleMainPanel',
      'toggleDetailPanel',
      'setLoading',
      'setImages',
    ]),
    async getLevels() {
      await this.$store.dispatch('getLevels')
          .then(() => {
            this.getVenues();
            this.getSiteOptions();
            // if (this.$route.params.venueId) {
            //   this.selectVenue(this.$route.params.venueId);
            // } else {
            //   this.toggleMainPanel(true);
            // }
            // this.toggleDetailPanel(true);
            this.setLoading(false);
          })
          .catch(e => {
            // eslint-disable-next-line
            console.error('SERVER ERROR: ', e);
          });
    },
    async getSiteOptions() {
      await this.$store.dispatch('getSiteOptions')
          .then(() => {
            this.setLoading(false);
          })
          .catch(e => {
            // eslint-disable-next-line
            console.error('SERVER ERROR: ', e);
          });
    },
    getVenues() {
      this.$store.dispatch('getVenues')
          .then(() => {
            if (this.$route.params.venueId) {
              this.selectVenue(this.$route.params.venueId);
            } else {
              this.toggleMainPanel(true);
            }
            this.toggleDetailPanel(true);
            this.setLoading(false);
          })
          .catch(e => {
            // eslint-disable-next-line
            console.error('SERVER ERROR: ', e);
          });
    },
    getInitialImages() {
      this.$store.dispatch('getInitialImages')
          .then(() => {
            //
          })
    },
    selectVenue(venueId, noRoute) {
      this.isClosed = true;
      const id = parseInt(venueId);
      const venue = this.venues.find((v) => {
        return v.id === id;
      });
      this.setVenue(venue);

      if (venue.acf) {
        // console.log('get images');
        this.setImages(this.formatImages(venue.acf.images));
      }
      if (!noRoute) {
        this.$router.push({ name: 'venue', params: { venueId: venue.id } });
      }

    },
    formatImages(imgArr) {
      let tempArr = [];
      for (let i = 0; i < imgArr.length; i++) {
        tempArr.push(imgArr[i].sizes.large);
      }
      return tempArr;
    },
    toggleFullScreen() {
      // console.log('toggleFullScreen');

      const element = this.$el;


      if (!this.isFullScreen) {
        // this.updateFullScreen();
        if (element.requestFullscreen) {
          element.requestFullscreen();
          this.addListener('fullscreenchange');
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
          this.addListener('mozfullscreenchange');
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
          this.addListener('webkitfullscreenchange');
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
          this.addListener('MSFullscreenChange');
        }


      } else {
        // this.updateFullScreen();
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else {
          // console.error('cannot exit fullscreen');

        }
      }
    },
    addListener: function (e) {
      document.addEventListener(e, this.fullScreenHandler, false);
    },
  },
  mounted() {
    // eslint-disable-next-line
    // console.log('test: ');
    this.setLoading(true);
    this.getLevels();
    this.getInitialImages();
    // this.setImages(this.$store.state.images);
    // this.getLevels();
  },
  watch: {
    '$route'(to) {
      // console.log(to.params.venueId);
      // console.log(to);
      if (to.params.venueId) {
        // this.toggleMainPanel(false);
        this.toggleMainPanel(false);
        this.selectVenue(to.params.venueId, true);

      } else {
        this.toggleMainPanel(false);
      }

    }
  },
  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.toggleMainPanel(false);
    this.toggleDetailPanel(false);
    setTimeout(() => {
      next()
    }, 400)
    // next()
  }

}
</script>
